/* Novu theme — storefront behaviour (vanilla JS, no dependencies). */
(function () {
  'use strict';

  var N = window.Novu || {};
  var R = N.routes || {};
  var S = N.strings || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var once = function (el, key) { if (!el || el['nv_' + key]) return false; el['nv_' + key] = true; return true; };

  /* ── Money ─────────────────────────────────────────────────────────── */
  function money(cents) {
    var fmt = String(N.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    cents = Math.round(Number(cents) || 0);
    function fmtNum(n, dec, ts, ds) {
      ts = ts == null ? ',' : ts; ds = ds == null ? '.' : ds;
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmtNum(cents, 0);
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        default: return fmtNum(cents, 2);
      }
    });
  }

  /* ── Toast ─────────────────────────────────────────────────────────── */
  function toast(text, isError) {
    var host = document.getElementById('nv-toasts');
    if (!host) return;
    host.innerHTML = '';
    var t = document.createElement('div');
    t.className = 'nv-toast' + (isError ? ' is-error' : '');
    t.innerHTML = '<i></i><span></span>';
    t.lastChild.textContent = text;
    host.appendChild(t);
  }

  /* ── Cart ──────────────────────────────────────────────────────────── */
  var Cart = {
    drawer: function () { return document.getElementById('CartDrawer'); },
    open: function () {
      var d = Cart.drawer(); if (!d) return;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      var c = $('[data-drawer-close].btn', d); if (c) setTimeout(function () { c.focus(); }, 50);
    },
    close: function () {
      var d = Cart.drawer(); if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    },
    renderSections: function (sections) {
      if (!sections || !sections['cart-drawer']) return;
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('.nv-drawer');
      var cur = Cart.drawer();
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    },
    setCount: function (n, bump) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('is-empty', !n);
        if (bump) { el.classList.add('is-bump'); setTimeout(function () { el.classList.remove('is-bump'); }, 350); }
      });
    },
    refreshCount: function (bump) {
      return fetch(R.cart, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { Cart.setCount(c.item_count, bump); return c; })
        .catch(function () {});
    },
    add: function (items, opts) {
      opts = opts || {};
      items = items.filter(function (i) { return i && i.id; });
      if (!items.length) return Promise.reject(new Error('No items'));
      return fetch(R.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function (res) {
          Cart.renderSections(res.sections);
          Cart.refreshCount(true);
          if (opts.silent) return res;
          toast(S.added || 'Added to your cart');
          if (!document.body.classList.contains('template-cart')) setTimeout(Cart.open, 450);
          else setTimeout(function () { window.location.reload(); }, 600);
          return res;
        })
        .catch(function (err) {
          toast((err && (err.description || err.message)) || S.error || 'Could not add to cart', true);
          throw err;
        });
    },
    change: function (line, qty) {
      var body = $('[data-drawer-body]', Cart.drawer());
      if (body) body.classList.add('is-busy');
      return fetch(R.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) { Cart.renderSections(res.sections); Cart.setCount(res.item_count); })
        .catch(function () { toast(S.error || 'Something went wrong', true); if (body) body.classList.remove('is-busy'); });
    }
  };
  N.cart = Cart;

  // Flash a button label to "Added ✓" after a successful add.
  function flashAdded(btn, restore) {
    if (!btn) return;
    var html = btn.innerHTML;
    btn.textContent = (S.added_short || 'Added ✓');
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); if (restore) restore(); else btn.innerHTML = html; }, 1800);
  }

  /* ── Global click delegation ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var addBtn = t.closest('[data-add-variant]');
    if (addBtn) {
      e.preventDefault();
      addBtn.disabled = true;
      Cart.add([{ id: Number(addBtn.getAttribute('data-add-variant')), quantity: 1 }])
        .then(function () { flashAdded(addBtn); })
        .catch(function () {})
        .then(function () { addBtn.disabled = false; });
      return;
    }
    if (t.closest('[data-cart-open]') && !document.body.classList.contains('template-cart') && Cart.drawer()) {
      e.preventDefault(); Cart.open(); return;
    }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); Cart.close(); return; }
    var lc = t.closest('[data-line-change]');
    if (lc) { e.preventDefault(); Cart.change(Number(lc.getAttribute('data-line-change')), Number(lc.getAttribute('data-qty'))); return; }
    if (t.closest('[data-wishlist-open]')) { e.preventDefault(); window.location.href = (R.root || '/').replace(/\/$/, '') + '/pages/wishlist'; return; }
    var wish = t.closest('[data-wish]');
    if (wish) { e.preventDefault(); Wish.toggle(wish.getAttribute('data-wish')); return; }
    var sb = t.closest('[data-scroll-buy]');
    if (sb) {
      var target = document.getElementById('purchase');
      if (target) { e.preventDefault(); window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' }); }
      return;
    }
    var top = t.closest('[data-scroll-top]');
    if (top) {
      e.preventDefault();
      var buy = document.getElementById('purchase');
      window.scrollTo({ top: buy ? buy.getBoundingClientRect().top + window.scrollY - 90 : 0, behavior: 'smooth' });
    }
  });

  document.addEventListener('keydown', function (e) {
    var tag = (document.activeElement && document.activeElement.tagName) || '';
    var typing = /INPUT|TEXTAREA|SELECT/.test(tag);
    if (e.key === 'Escape') { Cart.close(); Search.close(); }
    if (e.key === '/' && !typing) { e.preventDefault(); Search.open(); }
  });

  /* ── Wishlist (browser storage) ────────────────────────────────────── */
  var Wish = {
    key: 'novu:wishlist',
    list: function () { try { return JSON.parse(localStorage.getItem(Wish.key)) || []; } catch (e) { return []; } },
    save: function (l) { try { localStorage.setItem(Wish.key, JSON.stringify(l)); } catch (e) {} },
    toggle: function (handle) {
      var l = Wish.list(), i = l.indexOf(handle);
      if (i > -1) l.splice(i, 1); else l.push(handle);
      Wish.save(l); Wish.paint();
    },
    paint: function () {
      var l = Wish.list();
      $$('[data-wish]').forEach(function (b) {
        var on = l.indexOf(b.getAttribute('data-wish')) > -1;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-wish-count]').forEach(function (c) { c.textContent = l.length; c.classList.toggle('is-empty', !l.length); });
    },
    renderPage: function () {
      var grid = $('[data-wishlist-grid]');
      if (!grid || !once(grid, 'wish')) return;
      var l = Wish.list();
      if (!l.length) { grid.innerHTML = '<p class="nv-muted"></p>'; grid.firstChild.textContent = grid.getAttribute('data-empty'); return; }
      var base = (R.root || '/').replace(/\/$/, '');
      Promise.all(l.map(function (h) {
        return fetch(base + '/products/' + encodeURIComponent(h) + '?section_id=product-card-render')
          .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (htmls) {
        grid.innerHTML = htmls.map(function (h) {
          var d = new DOMParser().parseFromString(h, 'text/html'), c = d.querySelector('.nv-card');
          return c ? c.outerHTML : '';
        }).join('');
        initCards(grid); Wish.paint();
      });
    }
  };

  /* ── Reveal on scroll ──────────────────────────────────────────────── */
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); revealIO.unobserve(e.target); } });
  }, { threshold: 0.1 }) : null;
  function initReveal(root) {
    $$('[data-reveal]', root).forEach(function (el) {
      if (!revealIO) { el.classList.add('is-visible'); return; }
      if (once(el, 'reveal')) revealIO.observe(el);
    });
  }

  /* ── Announcement bar ──────────────────────────────────────────────── */
  function initAnn(root) {
    $$('[data-ann]', root).forEach(function (bar) {
      if (!once(bar, 'ann')) return;
      var items = $$('[data-ann-item]', bar); if (items.length < 2) return;
      var i = 0, ms = Number(bar.getAttribute('data-interval')) || 4000;
      setInterval(function () {
        var cur = items[i]; cur.classList.add('is-out');
        setTimeout(function () {
          cur.hidden = true; cur.classList.remove('is-out');
          i = (i + 1) % items.length;
          var nx = items[i]; nx.classList.add('is-out'); nx.hidden = false;
          requestAnimationFrame(function () { requestAnimationFrame(function () { nx.classList.remove('is-out'); }); });
        }, 400);
      }, ms);
    });
  }

  /* ── Search ────────────────────────────────────────────────────────── */
  var Search = {
    el: function () { return $('[data-search]'); },
    open: function () {
      var s = Search.el(); if (!s) return;
      s.classList.add('is-open');
      $$('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); if (b.classList.contains('h-ghost')) b.classList.add('is-on'); });
      setTimeout(function () { var i = $('[data-search-input]', s); if (i) i.focus(); }, 60);
    },
    close: function () {
      var s = Search.el(); if (!s) return;
      s.classList.remove('is-open');
      var sug = $('[data-sug]', s); if (sug) sug.classList.remove('is-open');
      $$('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); b.classList.remove('is-on'); });
    }
  };
  function initSearch() {
    var s = Search.el(); if (!s || !once(s, 'search')) return;
    var input = $('[data-search-input]', s), box = $('[data-search-box]', s), sug = $('[data-sug]', s);
    var pop = $('[data-sug-popular]', s), res = $('[data-sug-results]', s), timer, seq = 0;
    $$('[data-search-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { s.classList.contains('is-open') ? Search.close() : Search.open(); });
    });
    input.addEventListener('focus', function () { box.classList.add('is-focus'); sug.classList.add('is-open'); });
    input.addEventListener('blur', function () { setTimeout(function () { box.classList.remove('is-focus'); sug.classList.remove('is-open'); }, 150); });
    $$('[data-sug-term]', s).forEach(function (b) {
      b.addEventListener('mousedown', function (e) { e.preventDefault(); input.value = b.getAttribute('data-sug-term'); run(); });
    });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    function esc(x) { var d = document.createElement('div'); d.textContent = x == null ? '' : String(x); return d.innerHTML; }
    function run() {
      var q = input.value.trim(), my = ++seq;
      if (!q) { pop.hidden = false; res.hidden = true; return; }
      var url = R.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
        if (my !== seq) return;
        var r = (j && j.resources && j.resources.results) || {}, html = '';
        var cols = r.collections || [], prods = r.products || [];
        if (cols.length) {
          html += '<div class="nv-sug__label" style="padding-top:6px">' + esc(S.departments || 'Departments') + '</div>';
          cols.forEach(function (c) { html += '<a class="nv-sug__row" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; });
        }
        if (prods.length) {
          html += '<div class="nv-sug__label">' + esc(S.products || 'Products') + '</div>';
          prods.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
            html += '<a class="nv-sug__row nv-sug__row--product" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(img) + (String(img).indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span></span>') +
              '<span style="font-size:14px;line-height:1.3">' + esc(p.title) + '</span><span style="font-size:14px">' + esc(money(Math.round(parseFloat(p.price) * 100))) + '</span></a>';
          });
        }
        if (!html) html = '<div class="nv-sug__empty">' + esc((S.no_results || 'No results for “[q]”.').replace('[q]', q)) + '</div>';
        res.innerHTML = html; pop.hidden = true; res.hidden = false;
      }).catch(function () {});
    }
  }

  /* ── Horizontal scrollers ──────────────────────────────────────────── */
  function initScrollers(root) {
    $$('[data-scroller]', root).forEach(function (sc) {
      if (!once(sc, 'scroll')) return;
      var sec = sc.closest('section') || root, step = Number(sc.getAttribute('data-step')) || 320;
      $$('[data-scroll-prev]', sec).forEach(function (b) { b.addEventListener('click', function () { sc.scrollBy({ left: -step, behavior: 'smooth' }); }); });
      $$('[data-scroll-next]', sec).forEach(function (b) { b.addEventListener('click', function () { sc.scrollBy({ left: step, behavior: 'smooth' }); }); });
    });
  }

  /* ── Hero slideshow ────────────────────────────────────────────────── */
  function initHero(root) {
    $$('[data-hero]', root).forEach(function (hero) {
      if (!once(hero, 'hero')) return;
      var imgs = $$('.nv-slide-img', hero), texts = $$('[data-slide]', hero), dots = $$('[data-dot]', hero);
      var wrap = $('[data-hero-text]', hero), n = texts.length, cur = 0, timer;
      var ms = Number(hero.getAttribute('data-interval')) || 6500;
      if (n < 2) return;
      function paintDots() {
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === cur);
          if (i === cur) { var bar = $('i', d); if (bar) { var c = bar.cloneNode(); bar.parentNode.replaceChild(c, bar); } }
        });
      }
      function go(i) {
        if (i === cur) return;
        wrap.classList.add('is-out');
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
        setTimeout(function () {
          texts.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
          cur = i; paintDots();
          requestAnimationFrame(function () { wrap.classList.remove('is-out'); });
        }, 260);
      }
      function start() { clearInterval(timer); timer = setInterval(function () { go((cur + 1) % n); }, ms); }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.getAttribute('data-dot'))); start(); }); });
      hero.addEventListener('shopify:block:select', function (e) {
        var i = texts.indexOf(e.target); if (i > -1) { clearInterval(timer); go(i); }
      });
      start();
    });
  }

  /* ── Product cards (size pills + quick add) ────────────────────────── */
  function initCards(root) {
    $$('[data-card]', root).forEach(function (card) {
      if (!once(card, 'card')) return;
      var vj = $('[data-variants]', card), variants = [];
      try { variants = vj ? JSON.parse(vj.textContent) : []; } catch (e) {}
      var pos = Number(card.getAttribute('data-size-pos'));
      var quick = $('[data-quick-add]', card), pills = $$('[data-size]', card);
      pills.forEach(function (p) {
        var val = p.getAttribute('data-size');
        var any = variants.some(function (v) { return v.available && v.options[pos] === val; });
        if (variants.length && !any) p.disabled = true;
        p.addEventListener('click', function () {
          pills.forEach(function (x) { x.classList.toggle('is-on', x === p); });
          var v = variants.filter(function (x) { return x.available && x.options[pos] === val; })[0];
          if (v && quick) { quick.setAttribute('data-variant-id', v.id); quick.textContent = quick.getAttribute('data-label') + ' · ' + val; }
        });
      });
      if (quick) quick.addEventListener('click', function (e) {
        e.preventDefault();
        quick.disabled = true;
        var label = quick.textContent;
        Cart.add([{ id: Number(quick.getAttribute('data-variant-id')), quantity: 1 }])
          .then(function () { flashAdded(quick, function () { quick.textContent = label; }); })
          .catch(function () {})
          .then(function () { quick.disabled = false; });
      });
    });
  }

  /* ── Product shelf filters + department rail ───────────────────────── */
  function initShelf(root) {
    $$('[data-shelf]', root).forEach(function (shelf) {
      if (!once(shelf, 'shelf')) return;
      var cards = $$('.nv-shelf__track [data-card]', shelf), track = $('.nv-shelf__track', shelf);
      var tabs = $$('[data-tab]', shelf), deptTab = $('[data-tab="dept"]', shelf);
      var kicker = $('[data-shelf-kicker]', shelf), title = $('[data-shelf-title]', shelf), empty = $('[data-shelf-empty]', shelf);
      var under = Number(shelf.getAttribute('data-under')) || 4000, dept = null;
      function apply(tab) {
        var shown = 0;
        cards.forEach(function (c) {
          var ok = tab === 'best' ? true :
            tab === 'new' ? c.getAttribute('data-new') === 'true' :
            tab === 'under' ? Number(c.getAttribute('data-price')) < under :
            (' ' + c.getAttribute('data-collections')).indexOf(' ' + dept.handle + ' ') > -1;
          c.hidden = !ok; if (ok) shown++;
        });
        if (empty) empty.hidden = shown > 0;
        tabs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-tab') === tab); });
        var isDept = tab === 'dept';
        deptTab.hidden = !isDept;
        if (isDept) deptTab.textContent = dept.title + ' ×';
        kicker.textContent = isDept ? shelf.getAttribute('data-dept-kicker') : shelf.getAttribute('data-default-kicker');
        title.textContent = isDept ? dept.title : shelf.getAttribute('data-default-title');
        $$('[data-dept]').forEach(function (d) { d.classList.toggle('is-active', isDept && d.getAttribute('data-dept') === dept.handle); });
        if (track) track.scrollLeft = 0;
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { var k = t.getAttribute('data-tab'); apply(k === 'dept' ? 'best' : k); });
      });
      $$('[data-dept]').forEach(function (d) {
        if (!once(d, 'dept')) return;
        d.addEventListener('click', function (e) {
          if (!d.getAttribute('data-dept')) return;
          e.preventDefault();
          dept = { handle: d.getAttribute('data-dept'), title: d.getAttribute('data-dept-title') };
          apply('dept');
          window.scrollTo({ top: shelf.getBoundingClientRect().top + window.scrollY - 84, behavior: 'smooth' });
        });
      });
    });
  }

  /* ── Feature spotlight (heat levels) ───────────────────────────────── */
  function initSpot(root) {
    $$('[data-spot]', root).forEach(function (spot) {
      if (!once(spot, 'spot')) return;
      var btns = $$('[data-level]', spot), bars = $$('[data-bars] span', spot), card = $('[data-spot-card]', spot);
      var n = btns.length; if (!n) return;
      var use = $('[data-spot-use]', spot), name = $('[data-spot-name]', spot), num = $('[data-spot-num]', spot);
      function set(i) {
        btns.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        var lvl = (i + 1) / n;
        bars.forEach(function (b, k) {
          var base = 0.3 + 0.7 * Math.sin((k / 15) * Math.PI), v = lvl * base;
          b.style.height = Math.round(8 + 92 * v) + '%';
          b.classList.toggle('is-hot', v > 0.4); b.classList.toggle('is-glow', v > 0.6);
        });
        var frac = n > 1 ? i / (n - 1) : 0.5;
        card.style.setProperty('--glow-x', Math.round(20 + 60 * frac) + '%');
        card.style.setProperty('--glow-pct', Math.round(30 + 65 * frac) + '%');
        if (use) use.textContent = btns[i].getAttribute('data-use');
        if (name) name.textContent = btns[i].getAttribute('data-name');
        var tEl = $('[data-spot-temp]', spot), tSub = $('[data-spot-temp-sub]', spot);
        if (tEl) tEl.textContent = btns[i].getAttribute('data-temp') || '';
        if (tSub) tSub.textContent = [btns[i].getAttribute('data-temp-alt'), btns[i].getAttribute('data-duration')].filter(Boolean).join(' · ');
        if (num) num.textContent = i + 1;
      }
      btns.forEach(function (b, k) { b.addEventListener('click', function () { set(k); }); });
      set(Math.min(Math.max(Number(spot.getAttribute('data-start')) || 0, 0), n - 1));
    });
  }

  /* ── Heat levels tabs ──────────────────────────────────────────────── */
  function initHeat(root) {
    $$('[data-heat]', root).forEach(function (sec) {
      if (!once(sec, 'heat')) return;
      var opts = $$('[data-heat-opt]', sec), panels = $$('[data-heat-panel]', sec);
      function set(i) {
        opts.forEach(function (o, k) { o.classList.toggle('is-on', k === i); o.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        panels.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
        sec.style.setProperty('--heat-color', opts[i].getAttribute('data-color'));
      }
      opts.forEach(function (o, k) { o.addEventListener('click', function () { set(k); }); });
      sec.addEventListener('shopify:block:select', function (e) { var k = opts.indexOf(e.target); if (k > -1) set(k); });
    });
  }

  /* ── Size guide unit toggle ───────────────────────────────────────── */
  function initUnits(root) {
    $$('[data-units]', root).forEach(function (sec) {
      if (!once(sec, 'units')) return;
      var btns = $$('[data-unit]', sec), table = $('[data-unit-table]', sec), key = 'novu:unit';
      function set(u) {
        btns.forEach(function (b) { var on = b.getAttribute('data-unit') === u; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        table.classList.toggle('is-cm', u === 'cm');
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { var u = b.getAttribute('data-unit'); set(u); try { localStorage.setItem(key, u); } catch (e) {} }); });
      try { var saved = localStorage.getItem(key); if (saved) set(saved); } catch (e) {}
    });
  }

  /* ── Bundle builder ────────────────────────────────────────────────── */
  function initKit(root) {
    $$('[data-kit]', root).forEach(function (kit) {
      if (!once(kit, 'kit')) return;
      var rows = $$('[data-kit-item]', kit), pct = Number(kit.getAttribute('data-pct')) || 0, off = Number(kit.getAttribute('data-off')) || 0;
      var note = $('[data-kit-note]', kit), full = $('[data-kit-full]', kit), total = $('[data-kit-total]', kit), btn = $('[data-kit-add]', kit);
      var T = window.Novu.strings || {};
      function sel() { return rows.filter(function (r) { return r.classList.contains('is-on'); }); }
      function paint() {
        var s = sel(), sum = s.reduce(function (a, r) { return a + Number(r.getAttribute('data-price')); }, 0);
        var disc = s.length >= 2 ? (off || Math.round(sum * pct / 100)) : 0;
        if (pct > 0 || off > 0) {
          note.textContent = s.length >= 2 ? (T.kit_save || '[n] items · you save [amt]').replace('[n]', s.length).replace('[amt]', money(disc))
            : s.length === 1 ? (off ? (T.kit_one_amt || 'Add 1 more item to save [amt]').replace('[amt]', money(off)) : (T.kit_one || 'Add 1 more item to save [pct]%').replace('[pct]', pct)) : (T.kit_none || 'Select items to build your bundle');
        } else {
          note.textContent = s.length ? (T.kit_count || '[n] selected').replace('[n]', s.length) : (T.kit_none || 'Select items to build your bundle');
        }
        full.hidden = !disc; full.textContent = money(sum);
        total.textContent = money(sum - disc);
        btn.disabled = !s.length;
        btn.textContent = s.length ? (s.length > 1 ? (T.kit_add_many || 'Add [n] items to cart') : (T.kit_add_one || 'Add 1 item to cart')).replace('[n]', s.length) : (T.kit_select || 'Select items');
      }
      rows.forEach(function (r) {
        r.addEventListener('click', function () { r.classList.toggle('is-on'); r.setAttribute('aria-pressed', r.classList.contains('is-on') ? 'true' : 'false'); paint(); });
      });
      btn.addEventListener('click', function () {
        var items = sel().map(function (r) { return { id: Number(r.getAttribute('data-variant-id')), quantity: 1 }; });
        if (!items.length) return;
        btn.disabled = true;
        Cart.add(items).then(function () { btn.textContent = T.kit_added || 'Bundle added ✓'; setTimeout(paint, 1800); })
          .catch(function () { paint(); });
      });
      paint();
    });
  }

  /* ── Accordions (one open per group) ───────────────────────────────── */
  function initAccordions(root) {
    $$('[data-accordion]', root).forEach(function (group) {
      if (!once(group, 'acc')) return;
      var items = $$('[data-acc]', group);
      items.forEach(function (it) {
        var b = $('[data-acc-btn]', it);
        b.addEventListener('click', function () {
          var open = !it.classList.contains('is-open');
          items.forEach(function (o) { o.classList.remove('is-open'); $('[data-acc-btn]', o).setAttribute('aria-expanded', 'false'); });
          if (open) { it.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  }

  /* ── Product page ──────────────────────────────────────────────────── */
  function initProduct(root) {
    $$('[data-product]', root).forEach(function (sec) {
      if (!once(sec, 'pdp')) return;
      var data; try { data = JSON.parse($('[data-product-json]', sec).textContent); } catch (e) { return; }
      var pct = Number(sec.getAttribute('data-pct')) || 0;
      var pairOff = Number(sec.getAttribute('data-pair-off')) || 0;
      var T = window.Novu.strings || {};

      // Gallery
      var main = $('[data-zoom]', sec), imgs = $$('img[data-media-id]', main), thumbs = $$('[data-thumb]', sec);
      var counter = $('[data-counter]', sec), idx = 0;
      function show(i) {
        if (!imgs.length) return;
        idx = (i + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === idx); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
        if (counter) counter.textContent = (idx + 1) + ' / ' + imgs.length;
        var th = thumbs[idx]; if (th && th.parentNode) th.parentNode.scrollTo({ left: th.offsetLeft - 12, behavior: 'smooth' });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(Number(t.getAttribute('data-thumb'))); }); });
      var pv = $('[data-img-prev]', sec), nx = $('[data-img-next]', sec);
      if (pv) pv.addEventListener('click', function () { show(idx - 1); });
      if (nx) nx.addEventListener('click', function () { show(idx + 1); });
      document.addEventListener('keydown', function (e) {
        if (/INPUT|TEXTAREA|SELECT/.test((document.activeElement || {}).tagName || '')) return;
        if (e.key === 'ArrowRight') show(idx + 1);
        if (e.key === 'ArrowLeft') show(idx - 1);
      });
      if (main && window.matchMedia('(hover: hover)').matches) {
        main.addEventListener('mousemove', function (e) {
          var r = main.getBoundingClientRect();
          var o = Math.round((e.clientX - r.left) / r.width * 100) + '% ' + Math.round((e.clientY - r.top) / r.height * 100) + '%';
          imgs.forEach(function (im) { im.style.transformOrigin = o; });
          main.classList.add('is-zoom');
        });
        main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
      }
      // Touch swipe
      var sx = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); sx = null; });
      }

      // Variants
      var fieldsets = $$('[data-option]', sec);
      var input = $('[data-variant-input]');
      var qtyEl = $('[data-qty]', sec), qty = 1;
      var addBtns = $$('[data-add-main]');
      var priceEl = $('[data-price]', sec), compareEl = $('[data-compare]', sec), stickyMeta = $('[data-sticky-meta]');
      var pairs = data.pairs || [];
      var pairRows = $$('[data-pair-row]', sec);
      var pairsOn = function () { return pairs.filter(function (p) { return p.on && (!p.valid || p.valid()); }); };
      var saveEl = $('[data-save]', sec), buyNow = $('[data-buy-now]', sec);
      var checkoutOnly = sec.hasAttribute('data-checkout-only');
      var goCheckout = function () { window.location.href = (R.root || '/').replace(/\/$/, '') + '/checkout'; };
      var selected = fieldsets.map(function (fs) { var on = $('.is-on', fs); return on ? on.getAttribute('data-value') : null; });
      var variant = findVariant() || data.variants.filter(function (v) { return v.id === Number(input && input.value); })[0] || data.variants[0];
      var busy = false;

      function findVariant() {
        if (!fieldsets.length) return data.variants[0];
        return data.variants.filter(function (v) { return selected.every(function (val, i) { return v.options[i] === val; }); })[0];
      }
      function label() {
        if (!variant || !variant.available) return variant ? (T.soldOut || 'Sold out') : (T.unavailable || 'Unavailable');
        var main = variant.price * qty;
        var on = pairsOn();
        if (on.length) {
          var total = Math.round(on.reduce(function (sum, p) { return sum + p.price; }, main) * (1 - pct / 100)) - pairOff * on.length;
          var word = on.length > 1
            ? (checkoutOnly ? (T.buyBundle || 'Buy bundle') : (T.addBundle || 'Add bundle'))
            : (checkoutOnly ? (T.buyBoth || 'Buy both') : (T.addBoth || 'Add both'));
          return word + ' — ' + money(total);
        }
        return (checkoutOnly ? (T.buyNow || 'Buy now') : (T.addToCart || 'Add to cart')) + ' — ' + money(main);
      }
      function paint() {
        addBtns.forEach(function (b) {
          b.disabled = !variant || !variant.available;
          if (!busy) b.textContent = label();
        });
        if (variant) {
          if (priceEl) priceEl.textContent = money(variant.price);
          if (compareEl) { compareEl.hidden = !(variant.compare > variant.price); compareEl.textContent = money(variant.compare); }
          if (saveEl) {
            var sp = variant.compare > variant.price ? Math.floor((variant.compare - variant.price) * 100 / variant.compare) : 0;
            saveEl.hidden = !sp; saveEl.textContent = (T.save_pct || 'Save [pct]%').replace('[pct]', sp);
          }
          if (buyNow) buyNow.disabled = !variant.available;
          if (stickyMeta) stickyMeta.textContent = (fieldsets.length ? variant.title + ' · ' : '') + money(variant.price);
          if (input) input.value = variant.id;
        }
        // Mark values that can't combine with the current selection
        fieldsets.forEach(function (fs, i) {
          $$('[data-value]', fs).forEach(function (b) {
            var val = b.getAttribute('data-value');
            var ok = data.variants.some(function (v) {
              return v.available && v.options[i] === val && selected.every(function (s, j) { return j === i || v.options[j] === s; });
            });
            b.classList.toggle('is-unavailable', !ok);
          });
          var lbl = $('[data-option-value]', fs); if (lbl) lbl.textContent = selected[i] || '';
        });
      }
      fieldsets.forEach(function (fs, i) {
        $$('[data-value]', fs).forEach(function (b) {
          b.addEventListener('click', function () {
            selected[i] = b.getAttribute('data-value');
            $$('[data-value]', fs).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            variant = findVariant();
            if (!variant || !variant.available) {
              // Prefer an available variant that keeps this choice
              var alt = data.variants.filter(function (v) { return v.available && v.options[i] === selected[i]; })[0];
              if (alt && !variant) {
                selected = alt.options.slice(0, fieldsets.length);
                fieldsets.forEach(function (f, k) { $$('[data-value]', f).forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-value') === selected[k]); }); });
                variant = alt;
              }
            }
            if (variant) {
              if (variant.media) { var k = imgs.map(function (im) { return Number(im.getAttribute('data-media-id')); }).indexOf(variant.media); if (k > -1) show(k); }
              try { var u = new URL(window.location.href); u.searchParams.set('variant', variant.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
            }
            paint();
          });
        });
      });

      var dec = $('[data-qty-dec]', sec), inc = $('[data-qty-inc]', sec);
      if (dec) dec.addEventListener('click', function () { qty = Math.max(1, qty - 1); qtyEl.textContent = qty; paint(); });
      if (inc) inc.addEventListener('click', function () { qty += 1; qtyEl.textContent = qty; paint(); });
      pairRows.forEach(function (row) {
        var i = Number(row.getAttribute('data-pair-row')), p = pairs[i]; if (!p) return;
        var tog = $('.nv-pair__toggle', row), info = $('[data-pair-info]', row), sels = $$('[data-pair-opt]', row), priceOut = $('[data-pair-price]', row);
        var set = function (on) { p.on = on; row.classList.toggle('is-on', on); if (tog) tog.setAttribute('aria-pressed', on ? 'true' : 'false'); paint(); };
        // Click anywhere on the row (except the option selects, info button and popover) toggles the add-on
        row.addEventListener('click', function (e) {
          if (e.target.closest('select, .nv-pair__info, .nv-pairpop')) return;
          set(!p.on);
        });
        var pick = function () {
          var vals = sels.map(function (x) { return x.value; });
          var match = function (v) { return vals.every(function (val, k) { return v.options[k] === val; }); };
          var v = p.variants.filter(function (x) { return x.available && match(x); })[0];
          sels.forEach(function (x) { x.classList.toggle('is-unavailable', !v); });
          row.classList.toggle('is-invalid', !v);
          if (!v) { paint(); return; }
          p.variant = v.id; p.price = v.price;
          if (priceOut) priceOut.innerHTML = pairOff ? '<b>' + money(Math.max(0, v.price - pairOff)) + '</b> <s>' + money(v.price) + '</s>' : money(v.price);
          if (!p.on) set(true); else paint();
        };
        sels.forEach(function (x) { x.addEventListener('change', pick); });
        p.valid = function () { return !row.classList.contains('is-invalid'); };
        if (info) info.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = !row.classList.contains('is-pop');
          pairRows.forEach(function (r) { r.classList.remove('is-pop'); var b = $('[data-pair-info]', r); if (b) b.setAttribute('aria-expanded', 'false'); });
          row.classList.toggle('is-pop', open); info.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
      if (pairRows.length) document.addEventListener('click', function (e) {
        if (e.target.closest('[data-pair-row]')) return;
        pairRows.forEach(function (r) { r.classList.remove('is-pop'); var b = $('[data-pair-info]', r); if (b) b.setAttribute('aria-expanded', 'false'); });
      });
      var pushPairs = function (items) { pairsOn().forEach(function (p) { items.push({ id: p.variant, quantity: 1 }); }); return items; };

      addBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          if (!variant || !variant.available || busy) return;
          var items = pushPairs([{ id: variant.id, quantity: qty }]);
          busy = true; addBtns.forEach(function (x) { x.disabled = true; });
          if (checkoutOnly) {
            Cart.add(items, { silent: true }).then(goCheckout).catch(function () { busy = false; paint(); });
            return;
          }
          Cart.add(items).then(function () {
            addBtns.forEach(function (x) { x.textContent = S.added_short || 'Added ✓'; });
            setTimeout(function () { busy = false; paint(); }, 1800);
          }).catch(function () { busy = false; paint(); });
        });
      });

      if (buyNow) buyNow.addEventListener('click', function () {
        if (!variant || !variant.available) return;
        var items = pushPairs([{ id: variant.id, quantity: qty }]);
        buyNow.disabled = true;
        Cart.add(items, { silent: true })
          .then(goCheckout)
          .catch(function () { buyNow.disabled = false; });
      });

      // Delivery estimate (business days, weekends skipped)
      var eta = $('[data-eta]', sec);
      if (eta) {
        var addBiz = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
        var fmt = function (d) { try { return d.toLocaleDateString(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString().slice(4, 10); } };
        var now = new Date();
        var a = fmt(addBiz(now, Number(eta.getAttribute('data-min')) || 0)), z = fmt(addBiz(now, Number(eta.getAttribute('data-max')) || 0));
        var tpl = eta.getAttribute('data-text') || 'Order today, get it between [start] and [end].';
        var esc = function (x) { var d = document.createElement('div'); d.textContent = x; return d.innerHTML; };
        $('[data-eta-text]', eta).innerHTML = esc(tpl).replace('[start]', '<b>' + esc(a) + '</b>').replace('[end]', '<b>' + esc(z) + '</b>');
        eta.hidden = false;
      }

      // Sticky add-to-cart bar
      var sticky = $('[data-sticky]'), row = $('[data-buy-row]', sec);
      if (sticky && row) {
        // Scroll-position check (not IntersectionObserver) so fast jumps and anchor links still toggle it.
        var ticking = false, last = null;
        var check = function () {
          ticking = false;
          var on = row.getBoundingClientRect().bottom < 0;
          if (on === last) return; last = on;
          sticky.classList.toggle('is-visible', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          document.body.classList.toggle('has-sticky', on);
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
        window.addEventListener('resize', check);
        check();
      }
      paint();
    });
  }

  /* ── Boot ──────────────────────────────────────────────────────────── */
  function init(root) {
    root = root || document;
    initReveal(root); initAnn(root); initScrollers(root); initHero(root); initCards(root);
    initShelf(root); initSpot(root); initHeat(root); initUnits(root); initKit(root); initAccordions(root); initProduct(root);
    Wish.paint();
  }
  function boot() { initSearch(); init(document); Wish.renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('[data-search]')) initSearch(); init(e.target); });
})();
